import { Link } from "react-router-dom";
import ResourceManager from "@/components/common/ResourceManager";
import { DeadlineBadge } from "@/components/common/Badges";
import { fdate, daysUntil } from "@/lib/format";

export const LICENSE_CATEGORIES = ["AM", "A1", "A2", "A", "B", "BE", "C1", "C", "CE", "D1", "D", "DE"];

export const licenseLevel = (d) => {
  const n = daysUntil(d);
  if (n == null) return "neutral";
  if (n < 0) return "critical";
  if (n < 30) return "warning";
  return "ok";
};

const LicenseCell = ({ r }) => {
  if (!r.license_expiry) return <span className="text-[#8695AB]">—</span>;
  const n = daysUntil(r.license_expiry);
  const level = licenseLevel(r.license_expiry);
  return (
    <DeadlineBadge level={level}>
      <span data-testid="driver-license-badge">{fdate(r.license_expiry)}{n < 0 ? " · expiré" : n < 30 ? ` · ${n} j` : ""}</span>
    </DeadlineBadge>
  );
};

const urlFilters = {
  permis: { label: (v) => `Permis expirant < ${v} jours`, test: (r, v) => r.license_expiry && daysUntil(r.license_expiry) < Number(v) },
};

export default function Drivers() {
  const columns = [
    { key: "name", label: "Nom", render: (r) => <Link to={`/drivers/${r.id}`} onClick={(e) => e.stopPropagation()} className="font-medium text-[#001A3B] hover:underline" data-testid="driver-name-link">{r.first_name} {r.last_name}</Link> },
    { key: "email", label: "Email" },
    { key: "company", label: "Société" },
    { key: "current_vehicle", label: "Véhicule actuel", render: (r) => r.current_vehicle || <span className="text-[#8695AB]">—</span> },
    { key: "license_categories", label: "Catégories", render: (r) => (r.license_categories?.length ? <span className="font-mono text-xs">{r.license_categories.join(" · ")}</span> : <span className="text-[#8695AB]">—</span>) },
    { key: "license_points", label: "Points", render: (r) => (r.license_points ?? r.license_points === 0 ? `${r.license_points}/12` : "—") },
    { key: "license_expiry", label: "Permis (validité)", render: (r) => <LicenseCell r={r} /> },
  ];
  const fields = [
    { key: "first_name", label: "Prénom" },
    { key: "last_name", label: "Nom" },
    { key: "email", label: "Email" },
    { key: "company", label: "Société" },
    { key: "status", label: "Statut", type: "select", options: ["Actif", "Inactif", "Départ"] },
    { key: "_section_license", label: "Permis de conduire", type: "section" },
    { key: "license_number", label: "N° de permis" },
    { key: "license_points", label: "Nombre de points", type: "number" },
    { key: "license_issue_date", label: "Date de délivrance", type: "date" },
    { key: "license_expiry", label: "Date d'expiration", type: "date" },
    { key: "license_categories", label: "Catégories", type: "multi", options: LICENSE_CATEGORIES },
  ];
  return (
    <ResourceManager
      title="Conducteurs" subtitle="Collaborateurs et titulaires de véhicules de fonction." resource="employees" exportCollection="employees"
      columns={columns} fields={fields} defaultForm={{ status: "Actif" }} archivable urlFilters={urlFilters}
      attach={{ refType: "license", category: "Permis", label: "Ajouter le scan du permis" }}
    />
  );
}
